<template>
  <section>
    <h1 class="section-head">เพิ่มรายการสั่งซื้อ {{ supplier.name }}</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"><i class="fas fa-arrow-left"></i>Back</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-success" :class="loadingClass" @click="submit" v-if="products.length > 0"><i class="fas fa-save"></i>บันทึก</button>
          </div>
        </div>
      </div>
    </nav>

    <div class="columns">
      <div class="column">
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">ซัพพลายเออร์</label>
              <b-field :type="alert.supplier.type" :message="alert.supplier.msg">
                <b-select placeholder="โปรดเลือกซัพพลายเออร์" v-model="supId" @input="supChanged" :disabled="this.$route.params.supId || this.$route.params.id ? true : false">
                  <option v-for="supplier in supplierList" :value="supplier.id" :key="supplier.id">
                    {{ supplier.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Attention</label>
              <b-input v-model="order.attention" placeholder="Attention"></b-input>
            </div>
            <div class="field"></div>
          </div>
        </div>
      </div>
      <div class="column">
        <h2 class="section-sub-head">Ship to Company</h2>
        <div>
          <b-autocomplete
            v-model="customerSelectedName"
            placeholder="e.g. Pestgaurd"
            :clear-on-select="true"
            :keep-first="true"
            :open-on-focus="true"
            :data="filteredCustomerObj"
            field="name"
            @select="selectedCustomer"
            :disabled="customerList.length < 1"
          >
          </b-autocomplete>
        </div>

        <b-table :data="customerSelected" :hoverable="true" v-if="customerSelected.length > 0" class="table-style">
          <template slot-scope="props">
            <b-table-column field="name" label="ชื่อบริษัท" width="90%">
              {{ props.row.name }}
            </b-table-column>

            <b-table-column field="options" label="options" width="10%">
              <button class="button is-small is-danger is-rounded is-centered" @click="deleteCustomer(props)">ลบ</button>
            </b-table-column>
          </template>
        </b-table>

        <div class="notification has-text-centered is-small margin-top-15" v-if="customerSelected.length < 1">กรุณาเลือกบริษัทปลายทาง</div>
      </div>
    </div>

    <div v-for="(customerSelectedDisplay, key) in customerSelected" :key="key" class="table-container">
      <h3 class="section-sub-head">
        {{ customerSelectedDisplay.name }} {{ customerSelectedDisplay.id }}
        <button class="button is-small is-info is-rounded is-centered is-pulled-right" @click="openModal(customerSelectedDisplay.id)">เพิ่มผลิตภัณฑ์</button>
      </h3>
      <b-table
        :data="order.items"
        selectable
        @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isLoading"
        v-if="typeof order.items !== 'undefined' && order.items.length > 0 && checkCustomerItem(customerSelectedDisplay.id)"
        class="table-style"
      >
        <template slot-scope="props" v-if="props.row.cus_id == customerSelectedDisplay.id">
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="150">
            {{ props.row.pro_name }}
          </b-table-column>

          <b-table-column field="price_buy" label="ราคาชื้อ" width="140"> {{ parseFloat(props.row.price_buy).formatMoney(2) }} บาท/{{ props.row.unit_buy_text }} </b-table-column>

          <b-table-column label="ส่วนลด(%)" width="30">
            <div class="field has-addons">
              <p class="control">
                {{ parseFloat(props.row.discount).formatMoney(2) }}
              </p>
            </div>
          </b-table-column>

          <b-table-column label="ส่วนลด(฿)" width="30">
            <div class="field has-addons">
              <p class="control">
                {{ parseFloat(props.row.discount_baht).formatMoney(2) }}
              </p>
            </div>
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนสั่ง" width="120">
            <div class="field has-addons">
              <p class="control">{{ parseFloat(props.row.amount).formatMoney(2) }} {{ props.row.unit_buy_text }}</p>
            </div>
          </b-table-column>

          <b-table-column field="name" label="รวม" width="130"> {{ parseFloat(props.row.price_total).formatMoney(2) }} บาท </b-table-column>

          <b-table-column field="remark" label="Remark" width="180">
            <div class="field">
              <p class="control">
                {{ props.row.remark }}
              </p>
            </div>
          </b-table-column>
        </template>
      </b-table>

      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์</div>
    </div>

    <b-modal :active.sync="isModalActive" @close="closeModal">
      <div class="modal-card product-add-modal" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">เพิ่มรายการผลิตภัณฑ์ จัดส่งให้ {{ modalValue.cus_name }}</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-three-quarters">
              <b-field label="ชื่อผลิตภัณฑ์">
                <b-autocomplete
                  v-model="productSelectingName"
                  placeholder="e.g. Product Name"
                  :keep-first="true"
                  :open-on-focus="true"
                  :data="filteredProductObj"
                  field="name"
                  @select="selectedProduct"
                  @input="recalculateTotoalPrice"
                  :disabled="products.length < 1"
                >
                </b-autocomplete>
              </b-field>
            </div>
            <div class="column">
              <b-field label="ราคา">
                <b-input :value="productSelecting != null ? productSelecting.price_buy : 0" type="text" placeholder="ราคา" readonly> </b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field label="ส่วนลด (%)">
                <b-input v-model="modalValue.discount" type="text" placeholder="ส่วนลด (%)" @input="recalculateTotoalPrice"> </b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field label="ส่วนลด (฿)">
                <b-input v-model="modalValue.discount_baht" type="text" placeholder="ส่วนลด (฿)" @input="recalculateTotoalPrice"> </b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="columns">
                <div class="column is-10">
                  <b-field label="จำนวน">
                    <b-input v-model="modalValue.amount" type="text" placeholder="จำนวน" @input="recalculateTotoalPrice"> </b-input>
                  </b-field>
                </div>
                <div class="column is-2">
                  <span class="unit_text">{{ productSelecting != null ? productSelecting.unit_buy_text : '-' }}</span>
                </div>
              </div>
            </div>
            <div class="column">
              <b-field label="รวมราคา">
                <b-input v-model="modalValue.price_total_text" type="text" placeholder="ราคา" readonly> </b-input>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field label="หมายเหตุ">
                <b-input v-model="modalValue.remark" type="textarea" placeholder="หมายเหตุ"> </b-input>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: space-between;">
          <button class="button is-pulled-right" type="button is-warning" @click="closeModal">ปิด</button>
          <button v-if="modalValue.isModalEdit" class="button is-center is-danger" type="button" @click="deleteEditingItem"><i class="fas fa-trash"></i>ลบรายการนี้</button>
          <button class="button is-primary is-pulled-right" @click="addProduct">เพิ่ม</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import Request from '@/libraries/request';
import ProductModel from '@/model/product_model';
import SupplierModel from '@/model/supplier_model';
import CustomerModel from '@/model/customer_model';
import PurchaseOrderModel from '@/model/purchaseorder_model';
import Const from '@/const/const';

export default {
  data() {
    return {
      order: {
        items: [],
        attention: '',
      },
      discount: [],
      discount_baht: [],
      amount: [],
      total: [],
      remark: [],
      received: [],
      customer: [],
      shipto_cus_id: [],
      customerSelectedName: '',
      customerSelected: [],
      supId: this.$route.params.supId ? this.$route.params.supId : null,
      isLoading: true,
      backPage: this.$route.params.supId ? '/supplier/view/' + this.$route.params.supId : this.$route.params.id ? '/purchaseorder/view/' + this.$route.params.id : '/purchaseorder',
      supplier: {},
      supplierList: {},
      customerList: [],
      products: [],
      alert: {
        supplier: {
          type: '',
          msg: '',
        },
      },
      productSelected: [],
      productSelecting: [],
      productSelectingName: '',
      loadingClass: '',
      isModalActive: false,
      modalValue: {},
      selectedItem: {},
      lastSelected: {},
    };
  },
  mounted() {
    this.isLoading = true;
    this.init();
  },
  computed: {
    filteredCustomerObj() {
      return this.customerList.filter(option => {
        if (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.customerSelectedName.toLowerCase()) >= 0
        ) {
          return option;
        } else {
          return false;
        }
      });
    },
    filteredProductObj() {
      return this.products.filter(option => {
        if (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.productSelectingName.toLowerCase()) >= 0
        ) {
          return option;
        } else {
          return false;
        }
      });
    },
  },
  methods: {
    async init() {
      this.order.items = [];
      try {
        this.supplierList = await SupplierModel.get_all_supplier();
        this.customerList = await CustomerModel.get_all_customer();

        if (this.$route.params.id) {
          this.order = await PurchaseOrderModel.get_order(this.$route.params.id);
          this.supId = this.order.sup_id;
          if (!this.order.items) {
            this.order.items = [];
          } else {
            for (const [key, item] of Object.entries(this.order.items)) {
              this.order.items[key].pro_id = item.pro_id;
              this.order.items[key].pro_name = item.name;
              this.order.items[key].amount = item.quantity;
              this.order.items[key].discount = item.discount;
              this.order.items[key].discount_baht = item.discount_baht;
              this.order.items[key].price_total = item.total_price;
              this.order.items[key].price_total_text = parseFloat(item.total_price).formatMoney(2);
              this.order.items[key].price_buy = item.price;
              this.order.items[key].unit_buy_text = item.unit_text;
              this.order.items[key].remark = item.remark;
              this.order.items[key].received = item.received;
              this.order.items[key].cus_id = item.shipto_cus_id;

              this.selectedCustomer(
                this.customerList.find(function(customer) {
                  if (customer.id == item.shipto_cus_id) {
                    return customer;
                  }
                }),
                false
              );
            }
          }
        }
        if (this.supId) {
          this.supplier = await SupplierModel.get_supplier(this.supId);
          this.products = await ProductModel.get_supplier_product(this.supId);
        }
      } catch (e) {
        this.$buefy.snackbar.open(e.message);
        this.$router.push('/supplier/view/' + this.supId);
      }
      this.isLoading = false;
    },
    async supChanged() {
      if (!this.$route.params.id) {
        this.isLoading = true;
        this.supplier = await SupplierModel.get_supplier(this.supId);
        this.products = await ProductModel.get_supplier_product(this.supId);
        this.discount = {};
        this.amount = {};
        this.total = {};
        this.order.attention = this.supplier.attention;
      }
      this.isLoading = false;
    },
    selectedCustomer(option, showToast = true) {
      if (option == null) {
        return false;
      }
      const isExist = this.customerSelected.filter(function(customer) {
        if (option != null) {
          return customer.id == option.id;
        }
      });
      if (isExist.length == 0) {
        this.customerList.splice(this.customerList.indexOf(option), 1);
        this.customerSelected.push(option);
        if (showToast) this.$buefy.toast.open("เพิ่มบริษัท '" + option.name + "' เป็นปลายทางรับสินค้าแล้ว");
      }
    },
    deleteCustomer(props) {
      this.$buefy.toast.open("ลบบริษัท '" + this.customerSelected[props.index].name + "' จากปลายทางรับสินค้าแล้ว");
      this.customerList.push(this.customerSelected[props.index]);
      for (const [key, value] of Object.entries(this.shipto_cus_id)) {
        if (value == props.row.id) {
          this.shipto_cus_id[key] = 0;
        }
      }
      this.customerSelected.splice(props.index, 1);
    },
    openModal(cus_id) {
      this.lastSelected = null;
      this.isModalActive = true;
      const cusSeclected = this.customerSelected.filter(function(customer) {
        if (customer.id == cus_id) {
          return customer;
        }
      });
      this.modalValue.cus_name = cusSeclected[0].name;
      this.modalValue.cus_type = cusSeclected[0].type;
      this.modalValue.cus_id = cus_id;
    },
    closeModal() {
      this.isModalActive = false;
      this.modalValue = {};
      this.productSelecting = {};
      this.productSelectingName = '';
      this.modalValue.isModalEdit = false;
    },
    recalculateTotoalPrice() {
      this.modalValue.price_total = this.modalValue.amount
        ? this.modalValue.amount * (this.productSelecting != null ? this.productSelecting.price_buy : 0) -
          this.modalValue.amount * (this.productSelecting != null ? this.productSelecting.price_buy : 0) * ((this.modalValue.discount ? this.modalValue.discount : 0) / 100) -
          (this.modalValue.discount_baht ? this.modalValue.discount_baht : 0)
        : 0;
      this.modalValue.price_total_text = parseFloat(this.modalValue.price_total).formatMoney(2);
    },
    selectedProduct(option) {
      this.productSelecting = option;
      //console.log(this.productSelecting);
      if (this.productSelecting !== null) {
        this.modalValue.pro_id = this.productSelecting.id;
        this.modalValue.pro_name = this.productSelecting.name;
        this.modalValue.unit_buy_text = this.productSelecting.unit_buy_text;
        this.modalValue.price_buy = this.productSelecting.price_buy;
      }
    },
    addProduct() {
      let item = this.modalValue;
      //console.log(this.productSelecting);
      // console.log("item: ",item);
      const isExist = this.order.items.filter(function(currentListedItem) {
        // console.log("currentListedItem: ",currentListedItem);
        if (currentListedItem.pro_id == item.pro_id && currentListedItem.cus_id == item.cus_id) {
          return currentListedItem;
        }
      });
      if (isExist.length > 0) {
        this.order.items.splice(this.order.items.indexOf(isExist[0]), 1);
      }
      this.order.items.push(item);
      this.closeModal();
    },
    selected(item) {
      // console.log(typeof item);
      if (this.lastSelected == item) {
        // console.log(item);
        this.isModalActive = true;
        this.modalValue = item;
        let currentProductItemSelected = null;
        this.products.forEach(function(productItem) {
          if (productItem.id == item.pro_id) {
            currentProductItemSelected = productItem;
          }
        });
        this.productSelecting = currentProductItemSelected;
        this.productSelectingName = this.productSelecting.name;
        this.modalValue.isModalEdit = true;
      } else {
        this.lastSelected = item;
      }
    },
    deleteEditingItem() {
      this.$buefy.dialog.confirm({
        title: 'ลบรายการสินค้า',
        message: 'คุณต้องการจะ <b>ลบ</b> รายการนี้ใช่หรือไม่?.',
        confirmText: 'ใช่',
        cancelText: 'ไม่',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.order.items.splice(this.order.items.indexOf(this.lastSelected), 1);
          this.closeModal();
        },
      });
    },
    checkCustomerItem(cus_id) {
      //console.log("Call!");
      let isExist = false;
      let cusId = cus_id;
      this.order.items.forEach(function(item) {
        //console.log(item.cus_id +" == "+ cusId,item.cus_id == cusId);
        if (item.cus_id == cusId) {
          isExist = true;
        }
      });
      //console.log(isExist);
      return isExist;
    },
    submit() {
      this.loadingClass = 'is-loading';
      //console.log(this.order.items);
      let data = this.order;
      data.orders = [];
      data.sup_id = this.supId;
      if (this.$route.params.id) {
        data.id = this.$route.params.id;
      }
      for (const [key, value] of Object.entries(this.order.items)) {
        let item = {};
        item.id = value.pro_id;
        item.amount = value.amount;
        item.discount = value.discount ? value.discount : 0;
        item.discount_baht = value.discount_baht ? value.discount_baht : 0;
        item.remark = value.remark ? value.remark : '';
        item.received = value.received ? value.received : '';
        item.shipto_cus_id = value.cus_id ? value.cus_id : '';
        data.orders.push(item);
      }

      Request.post('purchaseorder/order_add', data, res => {
        this.isLoading = false;
        this.loadingClass = '';
        if (res.data.status) {
          if (res.data.data.sup_id) {
            this.$buefy.snackbar.open('บันทึกสำเร็จ!');
            if (this.$route.name == 'PurchaseOrder_edit' || this.$route.name == 'PurchaseOrder_add') {
              this.$router.push({ path: '/purchaseorder/view/' + res.data.data.id });
            } else {
              this.$router.push({ path: '/supplier/view/' + res.data.data.sup_id });
            }
          } else {
            this.$router.push({ path: '/product/view/' + res.data.id });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.table-style {
  font-size: 0.8rem;
}
.product-add-modal {
  min-height: 480px;
}
.unit_text {
  margin-left: -28px;
  margin-top: 32px;
  padding-top: 6px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 3px;
  display: inline-block;
  border: 1px solid #e7e7e7;
  box-sizing: border-box;
  background-color: #e7e7e7;
}
.modal-header {
  border-bottom: 1px solid #a3a3a3;
}
.table-container {
  padding-bottom: 1rem;
  margin-bottom: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrder/add.vue